var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogyxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    viewBox: "0 0 154 51",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1255 39.3397V0H37.6108V39.3397H40.1255Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6885 26.2628C46.6885 34.1635 52.2099 39.9936 59.6992 39.9936C67.1886 39.9936 72.7099 34.1635 72.7099 26.2628C72.7099 18.3622 67.1886 12.5321 59.6992 12.5321C52.2099 12.5321 46.6885 18.3622 46.6885 26.2628ZM49.2578 26.2628C49.2578 19.5609 53.5765 14.8205 59.6992 14.8205C65.8219 14.8205 70.1406 19.5609 70.1406 26.2628C70.1406 32.9647 65.8219 37.7051 59.6992 37.7051C53.5765 37.7051 49.2578 32.9647 49.2578 26.2628Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0649 25.4455C77.0649 32.3654 81.4929 38.359 89.037 38.359C93.793 38.359 97.6743 35.9071 99.4783 31.7115V38.7949C99.4783 44.734 95.597 48.7115 89.8023 48.7115C84.7729 48.7115 81.2196 46.0417 80.2356 41.4647H77.7756C78.8689 47.4583 83.4063 51 89.7476 51C97.073 51 101.938 46.0962 101.938 38.7949V13.1859H99.9157L99.5877 19.2885C97.8383 14.9295 94.1757 12.5321 89.3103 12.5321C81.5476 12.5321 77.0649 18.5256 77.0649 25.4455ZM79.6343 25.4455C79.6343 19.7244 83.0783 14.8205 89.3103 14.8205C95.597 14.8205 99.041 19.343 99.041 25.391C99.041 31.5481 95.433 36.0705 89.201 36.0705C83.1329 36.0705 79.6343 31.2212 79.6343 25.4455Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.421 50.4006C108.514 50.6186 109.553 50.7276 110.974 50.7276C114.528 50.7276 116.933 49.1474 118.3 45.3878L129.944 13.1859H127.374L118.518 37.7051L109.28 13.1859H106.655L117.316 41.1378L116.004 44.6795C114.637 48.3846 112.013 48.3846 109.881 48.3846H107.421V50.4006Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.648 39.3397L142.739 28.0609L150.939 39.3397H154L144.488 26.2628L154 13.1859H150.993L142.848 24.4103L134.703 13.1859H131.641L141.099 26.1538L131.587 39.3397H134.648Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.292709L8.53659 5.20511V31.0738L0 26.1614V0.292709Z",
    fill: "#3FA34D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7588 39.258H26.8961V31.3906H9.08698L22.7588 39.258Z",
    fill: "#3FA34D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72822 33.4326L0 39.355H4.62851L7.087 35.3655L3.72822 33.4326Z",
    fill: "#3FA34D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5934 21.6135L14.9264 27.4282L11.6792 25.5596L14.0707 21.6135H18.5934Z",
    fill: "#3FA34D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogyxLogo);
export default __webpack_public_path__ + "static/media/logyxLogo.5a8fd65aeb5c4a5c8a6d277885e63eb1.svg";
export { ForwardRef as ReactComponent };